import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createTextVNode as _createTextVNode, createVNode as _createVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-19428a17"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { style: {"text-align":"left","padding-top":"0.25em","font-size":"1.25em"} }, " Items to wish for: ", -1))
const _hoisted_2 = { class: "five-star star-text" }
const _hoisted_3 = { class: "star-holder" }
const _hoisted_4 = /*#__PURE__*/_createTextVNode(" Base Probability for 5-Star Item Drops: 0.600% (Incl. guarantee: 1.600%) ")
const _hoisted_5 = { class: "four-star star-text" }
const _hoisted_6 = { class: "star-holder" }
const _hoisted_7 = /*#__PURE__*/_createTextVNode(" Base Probability for 4-Star Item Drops: 5.100% (Incl. guarantee: 13.000%) ")
const _hoisted_8 = { class: "three-star star-text" }
const _hoisted_9 = { class: "star-holder" }
const _hoisted_10 = /*#__PURE__*/_createTextVNode(" Base Probability for 3-Star Item Drops: 94.300% (Incl. guarantee: 85.400%) ")

import { Banner } from "@/types";
import BannerDetailsDropTable from "./BannerDetailsDropTable.vue";


export default /*#__PURE__*/_defineComponent({
  props: {
    banner: null
  },
  setup(__props: any) {

const props = __props as { banner: Banner }



return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", null, [
    _hoisted_1,
    _createElementVNode("p", _hoisted_2, [
      _createElementVNode("span", _hoisted_3, [
        (_openBlock(), _createElementBlock(_Fragment, null, _renderList(5, (index) => {
          return _createElementVNode("span", {
            key: index,
            class: "star-img"
          })
        }), 64))
      ]),
      _hoisted_4
    ]),
    _createVNode(BannerDetailsDropTable, {
      banner: __props.banner,
      rarity: 5
    }, null, 8, ["banner"]),
    _createElementVNode("p", _hoisted_5, [
      _createElementVNode("span", _hoisted_6, [
        (_openBlock(), _createElementBlock(_Fragment, null, _renderList(4, (index) => {
          return _createElementVNode("span", {
            key: index,
            class: "star-img"
          })
        }), 64))
      ]),
      _hoisted_7
    ]),
    _createVNode(BannerDetailsDropTable, {
      banner: __props.banner,
      rarity: 4
    }, null, 8, ["banner"]),
    _createElementVNode("p", _hoisted_8, [
      _createElementVNode("span", _hoisted_9, [
        (_openBlock(), _createElementBlock(_Fragment, null, _renderList(3, (index) => {
          return _createElementVNode("span", {
            key: index,
            class: "star-img"
          })
        }), 64))
      ]),
      _hoisted_10
    ]),
    _createVNode(BannerDetailsDropTable, {
      banner: __props.banner,
      rarity: 3
    }, null, 8, ["banner"])
  ]))
}
}

})